import React from 'react';

const About = () => {
    return(
        <div id="about">
        <section className="page-section bg-primary text-white mb-0 mt-5">
            <div className="container">

                <h2 className="page-section-heading text-center text-uppercase text-white">About Me </h2>

                <div className="divider-custom divider-light">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon"><i class="far fa-address-card"></i></div>
                    <div className="divider-custom-line"></div>
                </div>

                <div className="row">
                    <div className="col-lg-4 ml-auto"><p className="lead">
                    Motivated and self-driven engineering graduate possessing good technical expertise, extensive problem-solving skills and the ability to work under pressure.
                    </p></div>
                    <div className="col-lg-4 mr-auto"><p className="lead">A decent android developer and web designer with extraordinary UI and UX designing skills. Quick learner and excellent at teamwork.</p></div>
                </div>

                <div className="text-center mt-4">
                    <a className="btn btn-xl btn-outline-light" href="https://sajidlpu1.github.io/My-e-Resume/" target="_blank">
                    <i className="fas fa-poll-h mr-2"></i>My Resume
                    </a>
                </div>
            </div>
        </section>
        </div>
    );
}

export default About;
